import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

/**
 * Config se carga **en runtime** desde `/config.js` (window.__THINGS360_CONFIG__)
 * para permitir el mismo bundle en dev/staging/prod sin rebuild.
 *
 * Para `vitest` en jsdom hay un fallback con valores de tests.
 */
export interface RuntimeConfig {
  api_base_url: string;
  oidc_authority: string;
  oidc_client_id: string;
  oidc_redirect_uri: string;
  oidc_post_logout_redirect_uri: string;
  build_version: string;
  build_commit: string;
}

declare global {
  interface Window {
    __THINGS360_CONFIG__?: RuntimeConfig;
  }
}

const FALLBACK: RuntimeConfig = {
  api_base_url: '/api',
  oidc_authority: 'http://localhost/realms/things360',
  oidc_client_id: 'frontend-core',
  oidc_redirect_uri: 'http://localhost/auth/callback',
  oidc_post_logout_redirect_uri: 'http://localhost/',
  build_version: 'dev',
  build_commit: 'unknown',
};

export function getRuntimeConfig(): RuntimeConfig {
  if (typeof window !== 'undefined' && window.__THINGS360_CONFIG__) {
    return window.__THINGS360_CONFIG__;
  }
  return FALLBACK;
}

export function getOidcConfig(c: RuntimeConfig): AuthProviderProps {
  return {
    authority: c.oidc_authority,
    client_id: c.oidc_client_id,
    redirect_uri: c.oidc_redirect_uri,
    post_logout_redirect_uri: c.oidc_post_logout_redirect_uri,
    response_type: 'code',
    scope: 'openid profile email',
    automaticSilentRenew: true,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    onSigninCallback: () => {
      // Limpia la URL de los params del callback OIDC
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };
}
